export default {
  name: 'IndexServiceGridComponent',
  props: {
    //- 這個 component 的名稱
    refName: {
      type: String,
      required: true
    },
    //- 隔線系統
    colSize: {
      type: String,
      default: 'auto'
    },
    //- 格子外框顏色
    propsBorderColor: {
      type: String,
      default: '#0A94CC'
    },
    //- 是否顯示圖片
    showImg: {
      type: Boolean,
      default: true
    },
    //- 是否顯示文字
    showText: {
      type: Boolean,
      default: true
    },
    //- 按鈕圖片
    img: {
      type: String,
      default: null
    },
    //- 按鈕圖片(點擊後)
    img_click: {
      type: String,
      default: null
    },
    //- 目前按鈕順序
    nowIndex: {
      type: [String, Number],
      default: null
    },
    //- 目前點擊的按鈕
    nowClickTarget: {
      type: [String, Number],
      default: null
    },
    //- 圓框
    borderRadius: {
      type: [String, Number],
      default: 0
    },
    //- 文字
    text: {
      type: String,
      default: null,
    },
    //- 文字樣式
    textStyle: {
      type: Object,
      default: null,
    },
    //- 點擊後的文字樣式
    textClickStyle: {
      type: Object,
      default: null
    }
  },
  mounted(){
    
  },
  methods: {
    //- 隔線系統
    calculateCol: function(colSize) {
      return `col-${colSize}`;
    },
    //- 點擊後觸發
    clickHandler: function() {
      let vm = this;
      let info = {
        refName: vm.refName,
        nowIndex: vm.nowIndex
      }
      vm.$emit('clickServiceGridHandler', info);
    }
  },
  computed:{
    // 外框顏色
    borderColor() {
      return {
        '--borderColor': this.propsBorderColor
      }
    },
  }
}